(function (global, factory) {
  'use strict';

  if (typeof define === 'function' && define.amd) {
    // If supports for AMD is available return the value to the AMD Loader
    // and to the global (window) object in case any JS module.
    define('formValidator',[], function () {
      return (global.formValidator = factory(global));
    });
  } else if (typeof exports === 'object') {
    // If supports for Common JS is available export the module
    // and pass is value to the global (window) object in case non Common JS code
    // is expected to work
    module.exports = (global.formValidator = factory(global));
  } else {
    // If not support for AMD or Common JS is available register the module in the global scope.
    global.formValidator = factory(global);
  }
}(typeof window !== 'undefined' ? window : {}, function () {
  'use strict';

  let inputsSelector = "fieldset input:enabled:not([type='checkbox']):not([type='button']):not([type='submit']):not([type='hidden']), fieldset textarea, fieldset select:not([disabled])";

  let validateInput = function (inputField) {
    let input = inputField;
    input.value = input.value.trim();
    let isValidInput = true;
    let pattern = new RegExp(input.getAttribute('data-pattern'));
    let errorElement = input.parentElement.querySelector('[data-error-message]') ||
      input.parentElement.parentElement.querySelector('[data-error-message]') ||
      input.parentElement.querySelector('.ao-form-error-message');

    if ((!input.required && (input.value === '' || pattern.test(input.value))) ||
      (input.required && pattern.test(input.value)) ||
      (input.required && input.getAttribute('data-pattern') == null && input.value.trim().length > 0)) {
      errorElement.textContent = '';
      input.removeAttribute('aria-invalid');
      inputField.setCustomValidity('');
    } else {
      isValidInput = false;
      input.setAttribute('aria-invalid', true);
      input.setAttribute('aria-describedby', errorElement.id);
      input.classList.add('nhs_Error');

      if (input.required && input.value === '') {
        const errorRequiredMessage = errorElement.getAttribute('data-required-message');
        errorElement.textContent = errorRequiredMessage;
        inputField.setCustomValidity(errorRequiredMessage);
      } else {
        const errorInvalidMessage = errorElement.getAttribute('data-invalid-message');
        errorElement.textContent = errorInvalidMessage;
        inputField.setCustomValidity(errorInvalidMessage);
      }
    }

    return isValidInput;
  };

  let displayFormErrors = function () {
    let errorsList = document.querySelectorAll('[data-error-message]');

    for (let i = 0; i < errorsList.length; i += 1) {
      errorsList[i].style.display = 'block';
    }
  };

  let clearFormErrors = function (form) {
    let errorElements = form.querySelectorAll('[data-error-message]');
    let invalidInputs = form.querySelectorAll("[aria-invalid='true'][aria-describedby]");

    for (let i = 0; i < invalidInputs.length; i += 1) {
      invalidInputs[i].removeAttribute('aria-invalid');
      invalidInputs[i].removeAttribute('aria-describedby');
      invalidInputs[i].classList.remove('nhs_Error');
    }

    for (let i = 0; i < errorElements.length; i += 1) {
      errorElements[i].textContent = '';
    }
  };

  let clearForm = function (form) {
    let inputsList = form.querySelectorAll(inputsSelector);
    for (let i = 0; i < inputsList.length; i += 1) {
      inputsList[i].value = '';
    }

    clearFormErrors(form);
  };

  function addErrorClassToEmailSuggestions(form){
    const suggestionsContainer = form.parentElement.querySelector('[data-suggestions-container]');

    if(suggestionsContainer){
      suggestionsContainer.classList.add('suggestion_error');
    }
  }

  let validateForm = function (form, avoidFocusFirstInput) {
    let inputsList = form.querySelectorAll(inputsSelector);
    let isValidForm = true;

    clearFormErrors(form);

    for (let i = 0; i < inputsList.length; i += 1) {
      let currentInput = inputsList[i];
      let isValidInput;
      const inputName = currentInput.name.toLowerCase();

      // recommended name attributes by google
      // https://developers.google.com/web/updates/2015/06/checkout-faster-with-autofill
      switch (inputName) {
        case 'fname':
        case 'lname':
        case 'firstname':
        case 'lastname':
        case 'first': // Required by external code used to handle basic leads
        case 'last': // Required by external code used to handle basic leads
        case 'name':
        case 'postal':
        case 'zipcode':
        case 'password':
        case 'passwordconfirm':
        case 'businessphone':
        case 'phone':
        case 'userphonenumber':
        case 'textcomment':
        case 'preferredarrivaltime':
        case 'askstatelist':
        case 'askcommunitylist':
          isValidInput = validateInput(currentInput);
          isValidForm = isValidForm && isValidInput;
          break;
        case 'email':
        case 'mailaddress':
          isValidInput = validateInput(currentInput);
          isValidForm = isValidForm && isValidInput;
          addErrorClassToEmailSuggestions(form);
        default:
          break;
      }
    }

    if (!isValidForm && avoidFocusFirstInput !== true) {
      let firstInvalidElement = form.querySelector("input[aria-invalid='true']");
      if (firstInvalidElement) {
        firstInvalidElement.focus();
      }
    }

    displayFormErrors(form);

    return isValidForm;
  };

  return {
    validateForm: validateForm,
    clearForm: clearForm,
    clearFormErrors: clearFormErrors
  };
}));

